import { useState } from 'react';
import { Search, Car, PlusCircle } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { savApi } from './savApi';
import { errMsg } from '../invoice/api';

// Recherche d'abord dans l'agence ; une absence est normale pour une vente antérieure à Marge Auto
export function SavPlateLookup({ initial, onVehicle, onHorsHistorique, onResult }) {
    const [q, setQ] = useState(initial || '');
    const [res, setRes] = useState(null);
    const [err, setErr] = useState('');
    const search = () => {
        setErr('');
        savApi.lookup(q).then(r => { setRes(r); onResult?.(r); }).catch(e => { setRes(null); setErr(errMsg(e)); });
    };
    return (
        <div className="space-y-2" data-testid="sav-plate-lookup">
            <div className="flex gap-2">
                <div className="relative flex-1">
                    <Search className="w-4 h-4 text-gray-400 absolute left-2.5 top-2.5" />
                    <Input value={q} onChange={e => { setQ(e.target.value); setRes(null); }} onKeyDown={e => e.key === 'Enter' && q.trim().length >= 4 && search()}
                        placeholder="Immatriculation (ex. AB-123-CD)" className="h-9 pl-8 font-mono text-[13px] uppercase" data-testid="sav-plate-input" />
                </div>
                <Button variant="outline" className="h-9" disabled={q.trim().length < 4} onClick={search} data-testid="sav-plate-search">Rechercher</Button>
            </div>
            {err && <p className="text-[12px] text-red-600" data-testid="sav-plate-error">{err}</p>}
            {res?.statut === 'trouve' && res.vehicules.map(v => (
                <button key={v.id} type="button" onClick={() => onVehicle(v)} className="w-full text-left rounded-lg border border-gray-100 px-3 py-2 hover:bg-gray-50 text-[12px]" data-testid={`sav-plate-vehicle-${v.id}`}>
                    <Car className="w-3.5 h-3.5 inline mr-1 text-blue-600" /><b className="font-mono">{v.immatriculation}</b> {v.nom || v.modele} · {v.commercial || 'commercial inconnu'} · {v.date_vente ? `vendu le ${v.date_vente}` : 'en stock'}
                </button>
            ))}
            {res && res.statut !== 'trouve' && (
                <div className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 space-y-2 text-[12px] text-gray-600" data-testid={`sav-plate-${res.statut}`}>
                    <p>{res.statut === 'autre_agence'
                        ? "Ce véhicule n'est pas enregistré dans votre agence. Aucune donnée d'une autre agence n'est reprise."
                        : "Aucun véhicule enregistré avec cette immatriculation. C'est normal pour une vente antérieure à Marge Auto."}</p>
                    <Button size="sm" variant="outline" className="h-8 text-[12px]" onClick={() => onHorsHistorique(q.trim().toUpperCase())} data-testid="sav-create-hh">
                        <PlusCircle className="w-3.5 h-3.5 mr-1" />Créer un SAV pour un véhicule non enregistré
                    </Button>
                </div>
            )}
        </div>
    );
}
